
import * as defaultImport from "lodash/get";
export * from "lodash/get";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
